(function() {
  if (window.peoplrWpBlogFeedInit) {
    return;
  }
  window.peoplrWpBlogFeedInit = true;

  console.log('peoplr wp-blog-feed init');

  var tempEl = document.createElement('div');

  function toText(html) {
    tempEl.innerHTML = html || '';
    return (tempEl.textContent || tempEl.innerText || '').trim();
  }

  function truncateWords(text, count) {
    var words = (text || '').split(/\s+/).filter(Boolean);
    if (words.length <= count) {
      return text || '';
    }
    return words.slice(0, count).join(' ') + '...';
  }

  function getImageUrl(post) {
    if (!post || !post._embedded || !post._embedded['wp:featuredmedia'] || !post._embedded['wp:featuredmedia'][0]) {
      return '';
    }
    var media = post._embedded['wp:featuredmedia'][0];
    if (media.media_details && media.media_details.sizes && media.media_details.sizes.medium_large) {
      return media.media_details.sizes.medium_large.source_url || media.source_url || '';
    }
    return media.source_url || '';
  }

  function fallbackMessage(blogUrl) {
    var url = blogUrl || 'https://resources.peoplr.co/';
    return '<p class="blog-loading">Visit <a href="' + url + '">resources.peoplr.co</a> to see our latest posts.</p>';
  }

  function buildPost(post, fallbackLink) {
    var article = document.createElement('article');
    article.className = 'post-listing';

    var imgDiv = document.createElement('div');
    imgDiv.className = 'post-listing-img';
    var imageUrl = getImageUrl(post);
    if (imageUrl) {
      imgDiv.style.backgroundImage = 'url(' + encodeURI(imageUrl) + ')';
    }

    var contentWrap = document.createElement('div');
    contentWrap.className = 'post-list-content';

    var heading = document.createElement('h1');
    heading.className = 'post-list-heading';
    var link = document.createElement('a');
    var titleText = toText(post && post.title && post.title.rendered);
    link.href = (post && post.link) || fallbackLink || '#';
    link.title = 'Read ' + (titleText || 'post');
    link.textContent = titleText || 'Untitled';
    heading.appendChild(link);

    var excerpt = document.createElement('p');
    excerpt.textContent = truncateWords(toText(post && post.excerpt && post.excerpt.rendered), 50);

    var readMore = document.createElement('a');
    readMore.className = 'action-btn';
    readMore.href = (post && post.link) || fallbackLink || '#';
    readMore.textContent = 'Read More';

    contentWrap.appendChild(heading);
    contentWrap.appendChild(excerpt);
    contentWrap.appendChild(readMore);

    article.appendChild(imgDiv);
    article.appendChild(contentWrap);

    return article;
  }

  function render(container) {
    if (!container) {
      return;
    }

    var maxPosts = parseInt(container.getAttribute('data-max-posts'), 10);
    if (!maxPosts || maxPosts < 1) {
      maxPosts = 2;
    }

    var feedUrl = container.getAttribute('data-feed-url') || 'https://resources.peoplr.co/wp-json/wp/v2/posts';
    var blogUrl = container.getAttribute('data-blog-url') || 'https://resources.peoplr.co/';
    var url = feedUrl + (feedUrl.indexOf('?') === -1 ? '?' : '&') + 'per_page=' + maxPosts + '&_embed=1';

    if (!window.fetch) {
      container.innerHTML = fallbackMessage(blogUrl);
      return;
    }

    fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Bad response');
        }
        return response.json();
      })
      .then(function(posts) {
        if (!Array.isArray(posts) || !posts.length) {
          throw new Error('No posts found');
        }

        container.innerHTML = '';
        posts.forEach(function(post) {
          container.appendChild(buildPost(post, blogUrl));
        });
      })
      .catch(function() {
        container.innerHTML = fallbackMessage(blogUrl);
      });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-peoplr-wp-feed]');
    if (!nodes.length) {
      return;
    }
    nodes.forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
